export const BackIcon = ({ color = "#3293DC" }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5303 6.46967C14.8232 6.76257 14.8232 7.23744 14.5303 7.53033L10.0606 12L14.5303 16.4697C14.8232 16.7626 14.8232 17.2375 14.5303 17.5304C14.2374 17.8232 13.7625 17.8232 13.4696 17.5304L8.46963 12.5304C8.17678 12.2375 8.17678 11.7626 8.46963 11.4697L13.4696 6.46967C13.7625 6.17678 14.2374 6.17678 14.5303 6.46967Z"
                fill={color}
            />
            <rect
                x="0.75"
                y="0.75"
                width="22.5"
                height="22.5"
                rx="11.25"
                stroke={color}
                strokeWidth="1.5"
            />
        </svg>
    );
};
